@if (progresjon().visProgresjonsindikator) {
  @if (progresjon().aktivSak) {
    <div class="progresjon-kontainer" data-testid="sak-progresjon">
      <mat-progress-spinner mode="determinate" [value]="progresjon().aktivSak!.progresjon" diameter="75" strokeWidth="2"/>
      <div class="innhold" [ngClass]="{'tid-snart-oppbrukt': progresjon().aktivSak!.rest < 2}">
        <div class="tittel">{{ 'sak' | translate }} {{ progresjon().aktivSak!.sakNummer }}</div>
        <div class="verdi">{{ formaterTid(progresjon().aktivSak!.rest) }}</div>
        <div class="benevnelse">{{ tidsbenevnelse(progresjon().aktivSak!.rest) }}</div>
      </div>
    </div>
  }
  <div class="progresjon-kontainer">
    <mat-progress-spinner mode="determinate" [value]="progresjon().moeteprogresjonIProsent" diameter="75" strokeWidth="2"/>
    <div class="innhold" [class.tid-snart-oppbrukt]="progresjon().moetettidRest < 2">
      <div class="tittel">{{ 'møte' | translate }}</div>
      <div class="verdi">{{ formaterTid(progresjon().moetettidRest) }}</div>
      <div class="benevnelse">{{ tidsbenevnelse(progresjon().moetettidRest) }}</div>
    </div>
  </div>
}
